import { render, staticRenderFns } from "./ReminderCards.vue?vue&type=template&id=6ba9f942&"
import script from "./ReminderCards.vue?vue&type=script&lang=js&"
export * from "./ReminderCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports